import React from 'react';
import { Alert, Box, Typography } from '@mui/material';

import Button from './Button';

function StockSubsection({ children }) {
  return (
    <Box sx={{ mt: 2.5, pt: 2.5, borderTop: '1px solid', borderColor: 'divider' }}>
      {children}
    </Box>
  );
}

export default function CheckoutStockGate({ oosLines, loading, error, onGoToCart }) {
  if (loading) {
    return (
      <StockSubsection>
        <Typography variant="body2" color="text.secondary">
          Checking stock…
        </Typography>
      </StockSubsection>
    );
  }

  if (error) {
    return (
      <StockSubsection>
        <Alert severity="warning" sx={{ borderRadius: 2, mb: 0 }}>
          {error}
        </Alert>
      </StockSubsection>
    );
  }

  if (!oosLines?.length) return null;

  return (
    <StockSubsection>
      <Alert severity="error" sx={{ borderRadius: 2, mb: 0 }}>
        <Typography variant="subtitle2" fontWeight={700} gutterBottom>
          Some items are out of stock at this store
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2, mb: onGoToCart ? 2 : 0 }}>
          {oosLines.map((row) => (
            <li key={String(row.productId)}>
              <Typography variant="body2">
                {row.name} ({row.sku})
              </Typography>
            </li>
          ))}
        </Box>
        {onGoToCart ? (
          <Button fullWidth variant="outlined" onClick={onGoToCart} sx={{ borderRadius: '5px', mt: 0.5 }}>
            Go to cart
          </Button>
        ) : null}
      </Alert>
    </StockSubsection>
  );
}
